@if (isCapacitorApp()) {
  <ui-button
    (clicked)="openBarcodeScanner()"
    buttonStyle="outlined">
    <ui-icon
      faName="barcode"
      faStyle="light">
    </ui-icon>
  </ui-button>
}

@if (!mainButtonIsSplit()) {
  <ui-button
    (clicked)="mainClicked.emit()"
    class="main-button fill-width"
    [loading]="isLoading()"
    [disabled]="disabled() || isLoading()"
  >
    {{ mainButtonLabel() }}
  </ui-button>
} @else {
  <ui-split-button
    (primaryClicked)="mainClicked.emit()"
    (secondaryClicked)="secondaryClicked.emit()"
    [disabled]="disabled() || isLoading()"
    [loading]="isLoading()"
    [icon]="splitButtonIcon()"
    iconStyle="light"
    buttonStyle="filled"
    type="button"
  >
    {{ mainButtonLabel() }}
  </ui-split-button>
}

<ui-button class="side-sheet-button" buttonStyle="tonal" (clicked)="sideSheet.open()" [loading]="isLoading()">
  <ui-icon
    faName="euro-sign"
    faStyle="light">
  </ui-icon>
</ui-button>

<ng-template autoFocusTarget="first-heading" width="100vw" #sideSheet="SideSheetDirective" uiSideSheetSide="right">
  <ui-side-sheet-header (closeSideSheet)="sideSheet.close()">{{ sideSheetLabel() }}</ui-side-sheet-header>
  <div class="wrapper-side-sheet-content" tabindex="0">

    <div class="content">
      <ng-content select="[sideSheetContent]"></ng-content>
    </div>

    <hr>
    <div class="actions">
      <ng-content select="[sideSheetActions]"></ng-content>
    </div>
  </div>
</ng-template>
